module.exports = __webpack_public_path__ + "img/rpm-data.4e0ec2d1.svg";